import { User } from '@teachur/http-client';
import { FC } from 'react';

interface CourseInstructorProps {
  instructor: User;
  courseCode: string;
  creditHours: number;
}

export const CourseInstructor: FC<CourseInstructorProps> = ({
  instructor,
  courseCode,
  creditHours,
}) => {
  return (
    <div className="flex items-center gap-4 p-4 border-2 border-(--neutral-black-NB100) rounded-lg">
      {/* Instructor Avatar */}
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-(--primary-O100) text-(--primary-O900) font-bold">
        {instructor.firstName?.[0]}
        {instructor.lastName?.[0]}
      </div>

      {/* Instructor Info */}
      <div className="flex-1 flex flex-col gap-1">
        <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB1000)! font-semibold m-0!">
          {instructor.firstName} {instructor.lastName}
        </p>
        <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)! m-0!">
          Course Professor
        </p>
      </div>

      {/* Course Metadata */}
      <div className="flex flex-col items-end gap-1">
        <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)! m-0!">{courseCode}</p>
        <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)! m-0!">
          Course Number
        </p>
      </div>

      <div className="flex flex-col items-end gap-1">
        <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)! m-0!">
          {creditHours}
        </p>
        <p className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB700)! m-0!">Credit Hours</p>
      </div>
    </div>
  );
};
